import React, { FC } from "react"
import { useSelector } from "react-redux"

import { getFeatures, getProduct, getProductFilters } from "@/onboarding/features/product/selectors"
import routes from "@/routes"
import ButtonLink from "@/components/ButtonLink"
import { useDirtyForms } from "@/onboarding/features/product/DirtyFormsContext"

const RejectContractPeriodDetailsButton: FC = () => {
  const {
    season: { id: seasonId },
  } = useSelector(getProduct)
  const { contractPeriodId } = useSelector(getProductFilters)
  const features = useSelector(getFeatures)

  const { hasUnsavedChanges } = useDirtyForms()

  if (!features.general.product.rejectContractPeriodDetails) {
    return null
  }

  return (
    <div>
      <ButtonLink
        label={hasUnsavedChanges ? "You have unsaved changes" : "Submit Proposed Tour Changes"}
        button={{ variant: "success" }}
        disabled={hasUnsavedChanges}
        modal
        href={routes.new_onboarding_bidding_reject_contract_period_detail_path({
          season_id: seasonId,
          contract_period_id: contractPeriodId,
        })}
      />
    </div>
  )
}

export default RejectContractPeriodDetailsButton
